module.exports = __webpack_public_path__ + "img/Introduction_to_Algorithms.f3c7a14e.jpeg";